import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SttTabs, SttButtonFab, SttPage } from '../../../sporttia/all';
import MessageList from './MessageList';
import NewMessageDialog from '../newMessageDialog/NewMessageDialog';
import { usePermission } from '../../../lib/usePermission';
import { PERMISSIONS } from '../../../lib/permissions';

export default function SCMessages(): React.ReactElement {
    const { t } = useTranslation();
    const { can } = usePermission();
    const canWrite = can(PERMISSIONS.COMMUNICATION.CREATE);
    const [openedNewMessage, setOpenedNewMessage] = useState<boolean>(false);

    // -----| Render |-----
    return (
        <SttPage title={t('Messages')}>
            <SttTabs
                tabs={[
                    {
                        caption: t('Inbox'),
                        // icon: <ArrowDownwardIcon />,
                        component: <MessageList fold="INBOX" />,
                    },
                    {
                        caption: t('Sent'),
                        // icon: <ArrowUpwardIcon />,
                        component: <MessageList fold="SENT" />,
                    },
                ]}
            />

            {canWrite && (
                <SttButtonFab onClick={() => setOpenedNewMessage(true)} />
            )}

            <NewMessageDialog
                open={openedNewMessage}
                onClose={() => setOpenedNewMessage(false)}
            />
        </SttPage>
    );
}
